// actions are commited
import {FETCH_PRIVILEGES, GIVE_PRIVILEGES,FETCH_PRIVILEGES_WITH_REGIONS,GET_PRIVILEGES_WITH_REGIONS} from '../actions/types';

const initialState = {
    privileges: []
};

export default function (state = initialState, action) {
    switch (action.type) {

        case FETCH_PRIVILEGES_WITH_REGIONS :
            return {
                ...state,
                privileges: action.payload
            };
        case GET_PRIVILEGES_WITH_REGIONS:
            return {
                ...state
            }
        case FETCH_PRIVILEGES :
            return {
                ...state,
                privileges: action.payload
            };

        case GIVE_PRIVILEGES :
            return {
                ...state
            };

        default :
            return state;
    }
}